import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-landing-guias-web',
  templateUrl: './landing-guias-web.component.html',
  styleUrls: ['./landing-guias-web.component.css']
})
export class LandingGuiasWebComponent implements OnInit {

  constructor(private route: ActivatedRoute) { }

  ngOnInit(): void {
    // Al entrar a la página, asegurar que se ve desde arriba
    window.scrollTo(0, 0);

    // Si viene con un fragmento (ej: #precios), hacer scroll a esa sección
    this.route.fragment.subscribe(f => {
      if (f) {
        setTimeout(() => {
          this.scrollTo(f);
        }, 300); // Un pequeño delay para que el componente esté renderizado
      }
    });
  }

  scrollTo(elementId: string): void {
    const element = document.getElementById(elementId);
    if (element) {
      const offset = 100; // Altura aproximada del navbar + margen
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  }

}
